export default __webpack_public_path__ + "static/media/chocolate-wallpaper-2.b2715929.jpg";